var React = require('react');

function ArrowHorizontal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.7402 3.20854L20.7402 4.50214L6.29944 4.50214L6.29944 7.30054L0.359438 3.86854L6.29944 0.410136L6.29944 3.20854L20.7402 3.20854Z","fill":"#38A6FB"}));
}

ArrowHorizontal.defaultProps = {"width":"21","height":"8","viewBox":"0 0 21 8","fill":"none"};

module.exports = ArrowHorizontal;

ArrowHorizontal.default = ArrowHorizontal;
